import { CART_LOAD_ITEMS } from "../consts";

const initialState = {
    items: [],
    totalItems: 0,
    totalPrice: 0
}

const CartReducer = (state = initialState, action) => {
    
    if (action.type === CART_LOAD_ITEMS) {
        const items = action.items || [];
        const totalPrice = items.reduce((total, item) => total + item.debtor.price, 0);
        return {
            ...state,
            items: items,
            totalItems: items.length,
            totalPrice: totalPrice
        }
    }
    
    return state;
}

export default CartReducer;